export class SendPersona {
    apellidoMaterno:string ='';
    apellidoPaterno:string='';
    codVerifica:string='';
    nombres:string='';
    dni:string='';
    tipoDocumento:string=''
}